<template>
  <TopGradientBlockLayout class="md:h-auto">
    <div class="flex items-center mb-8">
      <div class="text-xl font-bold text-text leading-tight ">
        {{ $t('wizardIntroTitle') }}
      </div>
      <IconCross @click.native="disableWizard"
                 class="ml-auto text-red hover:text-red-light transition duration-200 cursor-pointer"/>
    </div>
    <div class="lg:pr-15">
      <div class="text-text-label text-md leading-8 mb-11" v-html="$t('wizardIntroText')">
      </div>
    </div>
    <div class="flex items-center lg:mb-2">
      <WizardVideoTour class="mr-6"/>
      <BaseButton theme="red" class="mr-12" @click="$router.push({name:'wizard'})">
        {{ $t('launchBtn') }}
      </BaseButton>
      <div @click="disableWizard" class="text-text-ternary text-sm border-b border-text-ternary
      hover:text-red-hover hover:border-red-hover transition duration-200 cursor-pointer">{{ $t('noThanks') }}
      </div>
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import IconCross from "@/components/icons/IconCross";
import WizardVideoTour from "@/components/cabinet/Wizard/WizardVideoTour";
import {mapActions} from "vuex";

export default {
  name: "WizardAlert",
  components: {WizardVideoTour, IconCross, TopGradientBlockLayout, BaseButton},
  methods: {
    ...mapActions('cabinet/user', ['disableWizard']),
  },
  i18n: {
    messages: {
      en: {
        wizardIntroTitle: 'Evaluate the features and customize the system for yourself!',
        wizardIntroText: 'MoneyKeeper is a functional personal finance system. Open a demo account with a step-by-step description of all sections to appreciate all its possibilities.' +
            '<br><br>' +
            'After that, you can run the setup wizard to personalize your accounts, income sources and categories expenses.',
        launchBtn: 'Launch Configuration Wizard',
        noThanks: 'Thanks, I\'ll figure it out myself'
      },
      ru: {
        wizardIntroTitle: 'Оцените возможности и настройте систему под себя!',
        wizardIntroText: 'MoneyKeeper - функциональная система личных финансов. Включите видео-тур с пошаговым описанием всех разделов чтобы оценить ее возможности.' +
            '<br><br>' +
            'После этого можете запустить мастер настройки для персонализации ваших счетов, источников дохода и категорий расходов.',
        launchBtn: 'Запустить мастер настройки',
        noThanks: 'Спасибо, разберусь самостоятельно'
      }
    }
  }
}
</script>